import { render, staticRenderFns } from "./MoveLeft.vue?vue&type=template&id=19a31254"
import script from "./MoveLeft.vue?vue&type=script&lang=js"
export * from "./MoveLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports